module.exports = __webpack_public_path__ + "static/media/GUIDE_0008_01.32d94177.jpg";